module.exports = __webpack_public_path__ + "img/opera_card1.7c71025a.png";